import md5 from 'js-md5';
import { API_HOST } from 'boot/helpers/env';
import { queryBot2 } from 'boot/helpers/queries';
import { clientQuery } from '../authServer/authServer.service';
import { storeRedirectUrl } from './redirectUrl.service';
import { Tokens } from './tokens.service';

/* eslint-disable no-underscore-dangle */
/* eslint-disable import/prefer-default-export */

// List of keys that should be redirected to specific URLs
const BAD_KEYS_REDIRECTS = [
    {
        keys: ['7511b3f8b923', 'b9b7f6d5c16e', '0ac839eeb053', '2fdf68a9a759', '65ab33d17316', 'fc086eeb4a10', 'ec35e22ac95b', 'baea4598ecab', 'ae433310667e', 'ebc146fa9cf0', '9f38cf1f9fc4', '79929d539448', 'ce57146a3e48', '94b59888ff9c', 'bf51e2c9d395', '606a75e62df7', '745217e7a12d', 'e7f39f468bdf', 'cd7b38ceec3f', 'c739134a0391', '97d93728770f', '6a93826ee7c1', 'e4c654f0f05f', 'ba70ede18f88', 'f8835354cf6d', '4c73d695630b', '91e8e556c4ad', '13ed8f8b0425', '98ce18dfb4dd', '84ac9ef34800', '83d5c46631f4', '034b7e85dcd5'],
        redirect: 'https://go.1t.ru/unti_fin',
    },
];

// Токен админки, подтверждённый accounts/self в этой загрузке страницы: гвард вызывает авторизацию на каждом
// переходе, а перепроверка нужна только для нового токена (вход, смена оператора, refresh)
let verifiedAdminToken = '';

export class Auth {
    _AUTH_LOG_TYPE = {
        1: 'Вход',
        2: 'Выход',
        3: 'Создание',
        4: 'Восстановление',
        5: 'Смена email',
        6: 'Установка флага "Суперадмин"',
        7: 'Снятие флага "Суперадмин"',
        8: 'Изменение роли',
        9: 'Изменение провайдера',
        10: 'Изменение курса',
    };

    _store;

    _query;

    user;

    constructor ({ store, query }) {
        this._store = store;
        this._query = query;
    }

    type (type) {
        return this._AUTH_LOG_TYPE[+type];
    }

    async authorization () {
        const tokenService = new Tokens();
        const key = this._query?.key || localStorage.getItem('key');

        if (Object.prototype.hasOwnProperty.call(this._query || {}, 'redirectUrl')) {
            storeRedirectUrl(this._query?.redirectUrl);
        }

        const badKeyRedirect = BAD_KEYS_REDIRECTS.find((r) => r.keys.includes(key));

        if (badKeyRedirect) {
            window.location.href = badKeyRedirect.redirect;

            return;
        }

        // добавил, потому что если есть ключ и мы в админке, он ломится получить токен по ключу
        // но здесь могут быть отвалы если перейти из админки или кампуса в лк
        const isAdminka = window.location?.pathname?.startsWith('/jM5a-1Pq8') || window.location?.pathname?.startsWith('/admin-login');

        if (key && !isAdminka) {
            if (this._query?.key) {
                tokenService.setTabScope(Boolean(this._query?.by_admin));
            }

            await tokenService.getTokenByKey(key);
        } else {
            try {
                const token = this._query?.token;

                if (token) {
                    tokenService.setTokens({
                        access_token: token,
                        refresh_token: token,
                    });
                }
            } catch (e) {
                console.log(e);
            }

            if (isAdminka && tokenService.accessToken && tokenService.accessToken === verifiedAdminToken) {
                return;
            }

            await tokenService.verifyToken();

            if (isAdminka && !tokenService.data) {
                window.location.href = `${window.location.origin}/admin-login`;

                return;
            }

            if (isAdminka) {
                verifiedAdminToken = tokenService.accessToken;
            }
        }

        // добавил, потому что если мы в админке, зачем нам проверять пользователя
        // но здесь могут быть отвалы если перейти из админки или кампуса в лк
        if (isAdminka) {
            return;
        }

        // console.groupCollapsed('🔒 Авторизация');
        // console.log(tokenService);
        this.user = await this._authByData(tokenService.data);
        // console.log({ User: this.user });
        // console.groupEnd();

        if (this._store.state.pages?.user) {
            return;
        }

        this._store.commit('pages/setUser', this.user);

        if (this._query?.by_admin) {
            localStorage.setItem('enter_by_admin', true);
        } else if (this._query?.key) {
            // Очищаем флаг только при новом входе по ключу без by_admin.
            localStorage.removeItem('enter_by_admin');
        }

        const ssoLastAuthKey = localStorage.getItem('ssoLastAuthKeyV2');

        if (key && key !== ssoLastAuthKey && window.location.hostname === URL.parse(process.env.API_HOST).hostname) {
            localStorage.setItem('ssoLastAuthKeyV2', key);

            return await clientQuery('/auth/login/key', {
                key,
                grant_type: 'key',
            });
        }
    }

    logout () {
        localStorage.removeItem('key');
        localStorage.removeItem('ssoLastAuthKeyV2');
        localStorage.removeItem('enter_by_admin');

        const tokenService = new Tokens();
        tokenService.clear();

        this._store.commit('pages/setUser', undefined);
    }

    exit () {
        if (!this._store.state.pages?.user) {
            let apiHost = API_HOST;
            const { host } = new URL(window.origin);

            if ([
                'xn--80adnyece.xn--80aecp0bbig3h.xn--p1ai',
                'xn--j1amdg6b.xn--n1afe.xn--p1ai',
                'xn--80aamepir7m.xn--n1afe.xn--p1ai',
            ].includes(host)) {
                apiHost = origin;
            }

            window.location.href = apiHost;
        }
    }

    async _authByData (data) {
        if (!data?.username && !data?.phone) {
            return;
        }

        let useQuery = 'get-user-by-auth';
        let queryData = { username: data.username };

        if (!data?.username && data?.phone) {
            useQuery = 'get-user-by-auth-phone';
            queryData = { phone: data.phone };
        }

        return await queryBot2(useQuery, queryData)
            .then(async (r) => {
                const student = await this._fetchStudentData(r);

                if (!student) {
                    localStorage.removeItem('key');
                }

                const key = md5(student.chat_id).slice(0, 12);
                localStorage.setItem('key', key);

                return student;
            }).catch((e) => {
                console.error(e);

                return null;
            });
    }

    async _fetchStudentData (studentData) {
        const student = studentData?.data[0];

        const tokenService = new Tokens();
        const hasTokens = tokenService.hasTokens();

        if (hasTokens && !student) {
            // если мы уже на этой странице, нас будет бесконечно редиректить
            if (!window.location?.pathname?.startsWith('/no-access')) {
                window.location.href = `${window.location.origin}/no-access`;
            }
        }

        for (const prop in student) {
            if (student[prop] === 'null' || student[prop] === null) {
                student[prop] = '';
            }
        }

        if (student.students_id && !student.student_id) {
            student.student_id = student.students_id;
        }

        return student;
    }
}
